import gql from 'graphql-tag';

export default gql`
  fragment formPostOtherTextFragment on FormPostOtherText {
    id
    value
    formBlockFieldOtherId
    createdAt
    updatedAt
  }
`;

